import React from "react";
import moment from "moment";
/*import Select from 'react-select';*/
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import Presenter from '../../../presenter.js'
// import RequestProperties from '../../request.props.js';
import {
  ButtonValidation,
  ButtonCancel
} from "../../../../../component/Button.js";
import { toast } from "react-toastify";
import SelectQuery from "../../../../../component/SelectQuery.js";
import FormHelper from "../../form.js";

import Request from "config/Request.js";
import handlingError from "utils/handlingError.js";

export default class ModalBooking extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      SelectedItem: null,
      clicked: false,
      is_process: false,
      Site: "",
      Location: "",
      Description: ""
    };

    this.state = Object.assign({}, this.initialState);

    this.onRegisterBooking = this.onRegisterBooking.bind(this);
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this);
    this.onFailed = this.onFailed.bind(this);
  }

  generateLabel(list, mapping) {
    return list.map((val, key) => {
      val.value = val[mapping.value];
      val.label = val[mapping.label];
      return val;
    });
  }

  handleSiteChange(event) {
    this.setState(
      {
        Site: event.value,
        Location: "",
        clicked: true
      },
      () => this._location.reload("", true)
    );
  }

  getLocationBySite(site) {
    return this.state.MASTER_LOCATION.filter((val, key) => {
      return val.Site === site;
    });
  }

  handleLocationChange(event) {
    this.setState({
      Location: event.value,
      clicked: true
    });
  }

  onRegisterBooking() {
    if (!FormHelper.ValidateFormBooking(this.state)) return;

    let payload = {
      Asset: this.state.SelectedItem.Alias,
      StartDate: this.props.dateBookingStart_UTC,
      FinishDate: this.props.dateBookingEnd_UTC,
      Site: this.state.Site,
      Location: this.state.Location,
      Description: this.state.Description
    };

    Request(
      "post",
      "register-booking",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      payload,
      [],
      this.onRegisterSuccess,
      this.onFailed
    );
    this.setState({ is_process: true });
  }

  onRegisterSuccess(params, response) {
    toast.success("Booking Success");
    this.props.onRegisterSuccess();
    this.props.closeModal();
    this.setState({ is_process: false });
  }

  onFailed(error) {
    this.setState({ is_process: false });
    handlingError(error);
  }

  onModalClose() {
    this.setState(this.initialState);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.selectedItem !== null) {
      nextState.SelectedItem = nextProps.selectedItem;
    }
    if (this.props.dateBookingStart === null && this.props.dateBookingEnd) {
      return false;
    }
    return true;
  }

  render() {
    const { is_process } = this.state;

    if (this.state.SelectedItem == null) {
      return null;
    }

    if (this.props.dateBookingStart == null && this.props.dateBookingEnd) {
      return null;
    }

    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.closeModal}
        onExit={() => this.onModalClose()}
      >
        <ModalHeader toggle={this.props.closeModal}>
          <span>Book Asset</span>
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Asset</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Username"
              readOnly
              value={this.state.SelectedItem.Name}
            />
          </div>
          <div className="row">
            <div className="form-group col-sm-6">
              <label>Start</label>
              <input
                type="text"
                className="form-control"
                readOnly
                value={moment(this.props.dateBookingStart).format("ll")}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Finish</label>
              <input
                type="text"
                className="form-control"
                readOnly
                value={moment(this.props.dateBookingEnd).format("ll")}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-6">
              <label className="required">Site</label>
              <SelectQuery
                name="Site"
                placeholder="Type Site"
                value={this.state.Site}
                urlKey="read-site-autocomplete"
                valKey="Alias"
                valLabel="Name"
                onChange={val => this.handleSiteChange(val)}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Location</label>
              <SelectQuery
                name="Location"
                placeholder="Type Location"
                value={this.state.Location}
                urlKey="read-location-autocomplete"
                valKey="Alias"
                valLabel="Name"
                extra={"site=" + this.state.Site}
                onRef={asd => (this._location = asd)}
                onChange={val => this.handleLocationChange(val)}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="col-sm-12">
              <label>Description</label>
              <textarea
                className="form-control"
                name="description"
                rows="5"
                onChange={e => this.setState({ Description: e.target.value })}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={this.props.closeModal}>cancel</ButtonCancel>
          <ButtonValidation
            is_process={is_process}
            onClick={() => this.onRegisterBooking()}
          >
            Book
          </ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Modal/ModalBooking.js